import { render, staticRenderFns } from "./TableInvestments.vue?vue&type=template&id=09b8b756&scoped=true&"
import script from "./TableInvestments.vue?vue&type=script&lang=js&"
export * from "./TableInvestments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b8b756",
  null
  
)

export default component.exports